<template>
  <div class="px-4">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết hoa hồng Tingbox cho CTV</h1>
      <div class="float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/list-tingbox-ctv')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
      </div>
      <hr />
    </div>
    <b-row class="gx-1">
      <!-- General Information -->
      <b-col cols="12" md="6">
        <b-card class="card-section">
          <div class="header-section">Thông tin chung</div>
          <div class="form-item">
            <div class="form-label">Thông tin merchant</div>
            <div class="form-input">
              <div>{{ txPayment?.merchantName || '' }}</div>
              <b-link :href="`mailto:${txPayment?.merchantEmail}`">
                {{ txPayment?.merchantEmail || '' }}
              </b-link>
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Loại ĐKKD</div>
            <div class="form-input">
              {{ txPayment?.registrationType === 'UNREGISTERED' ? 'Không ĐKKD' : 'Có ĐKKD' }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Tên thiết bị</div>
            <div class="form-input">{{ txPayment?.deviceCategory || '' }}</div>
          </div>

          <div class="form-item">
            <div class="form-label">Serial thiết bị</div>
            <div class="form-input">{{ txPayment?.serial || '' }}</div>
          </div>

          <div class="form-item">
            <div class="form-label">Mã hợp đồng/phụ lục</div>
            <div class="form-input">
              <b-link target="_blank" :href="`/contract-detail-ecommerce/${txPayment?.contractId}`">
                {{ txPayment?.contractCode || '' }}
              </b-link>
              <!-- :to="`/contracts/${txPayment?.contractId}`" -->
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Người hưởng</div>
            <div class="form-input">
              <div>{{ txPayment?.userSell?.name || '' }}</div>
              <b-link target="_blank" :href="`/staff/detail/?id=${txPayment?.userReceive?.id}`">
                {{ txPayment?.userSell?.email || '' }}
              </b-link>
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Người bán thiết bị</div>
            <div class="form-input">
              <div>{{ txPayment?.userReceive?.name || '' }}</div>
              <b-link target="_blank" :href="`/staff/detail/?id=${txPayment?.userReceive?.id}`">
                {{ txPayment?.userReceive?.email || '' }}
              </b-link>
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ngày xuất thiết bị</div>
            <div class="form-input">
              {{ formatDate(txPayment?.exportedTime) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ghi chú</div>
            <div class="form-input">
              {{ txPayment?.note }}
            </div>
          </div>
        </b-card>
      </b-col>

      <b-col cols="12" md="6">
        <!-- Payment Information -->
        <b-card class="card-section mb-3">
          <div class="header-section d-flex justify-content-between align-items-center">
            <span> Thông tin thanh toán </span>
            <div>
              <b-button
                variant="outline-danger"
                class="mr-2"
                size="sm"
                @click="handleOpenModal(txPayment, 'CANCEL_PAYMENT')"
                v-if="
                  txPayment?.status === 'PENDING_PAYMENT' &&
                  dataPermission &&
                  dataPermission.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CANCEL')
                "
                >Huỷ thanh toán</b-button
              >
              <b-button
                variant="outline-primary"
                v-if="
                  txPayment?.status === 'PENDING_PAYMENT' &&
                  dataPermission &&
                  dataPermission.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CONFIRM')
                "
                class="mr-2"
                size="sm"
                @click="handleOpenModal(txPayment, 'MARK_PAID')"
                >Thanh toán xong</b-button
              >
              <b-button
                variant="outline-success"
                v-if="
                  txPayment?.status === 'PAID' &&
                  txRecoupment?.status === 'CANCELED' &&
                  dataPermission &&
                  dataPermission.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CREATE')
                "
                class="mr-2"
                size="sm"
                @click="handleOpenModal(txPayment, 'CREATE_RECOUPMENT')"
                >Tạo truy thu</b-button
              >
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">Số tiền hóa hồng</div>
            <div class="form-input">
              {{ formatCurrency(txPayment?.amount) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ngày tạo</div>
            <div class="form-input">
              {{ formatDate(txPayment?.createdTime) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ngày thanh toán</div>
            <div class="form-input">
              {{ txPayment?.paidTime ? formatDate(txPayment?.paidTime) : '' }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Trạng thái</div>
            <div class="form-input">
              <span class="badge text-white" :class="getStatusType(txPayment?.status)">
                {{ getStatusLabel(txPayment?.status) }}
              </span>
            </div>
          </div>
        </b-card>

        <!-- Recoupment Information  -->
        <b-card class="card-section" v-if="txRecoupment">
          <div class="header-section d-flex justify-content-between align-items-center">
            <span>Thông tin truy thu</span>
            <div>
              <b-button
                variant="outline-primary"
                v-if="
                  txRecoupment?.status === 'NEED_RECOUPMENT' &&
                  dataPermission &&
                  dataPermission.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CONFIRM')
                "
                class="mr-2"
                size="sm"
                @click="handleOpenModal(txRecoupment, 'MARK_RECOUPED')"
                >Truy thu xong</b-button
              >
              <b-button
                variant="outline-danger"
                v-if="
                  txRecoupment?.status === 'NEED_RECOUPMENT' &&
                  dataPermission &&
                  dataPermission.includes('CNPS_DFS_TOP_COMMISSION_POLICY_CANCEL')
                "
                class="mr-2"
                size="sm"
                @click="handleOpenModal(txRecoupment, 'CANCEL_RECOUPMENT')"
                >Hủy truy thu</b-button
              >
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Số tiền truy thu</div>
            <div class="form-input">
              {{ formatCurrency(txRecoupment?.amount) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ngày tạo</div>
            <div class="form-input">
              {{ formatDate(txRecoupment?.createdTime) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Ngày truy thu</div>
            <div class="form-input">
              {{ formatDate(txRecoupment?.recoupmentTime) }}
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Trạng thái</div>
            <div class="form-input">
              <span class="badge text-white" :class="getStatusType(txRecoupment?.status)">
                {{ getStatusLabel(txRecoupment?.status) }}
              </span>
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">Lý do</div>
            <div class="form-input">
              {{ txRecoupment?.reasonRecoupment }}
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modal xác nhận các thay đổi -->
    <ModalComfirm @onLoad="loadData" ref="modalComfirm" />
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import ModalComfirm from './tingBoxCtv/ModalComfirm.vue'

  import { Detail } from '@/services/tingbox-ctv'
  import { mapGetters } from 'vuex'
  import { showMess } from '@/config/utils'

  export default {
    name: 'PaymentInfoCard',
    components: {
      ModalComfirm,
    },
    data() {
      return {
        txPayment: null,
        txRecoupment: null,
        id: '',
        isLoading: false,

        // status
        optionStatus: [
          {
            id: 'PENDING_PAYMENT',
            text: 'Chờ thanh toán',
            type: 'badge-warning',
          },
          {
            id: 'CANCELED',
            text: 'Đã huỷ',
            type: 'badge-danger',
          },
          {
            id: 'PAID',
            text: 'Đã thanh toán',
            type: 'badge-success',
          },
          {
            id: 'RECOUPED',
            text: 'Đã truy thu',
            type: 'badge-info',
          },
          {
            id: 'NEED_RECOUPMENT',
            text: 'Chờ truy thu',
            type: 'badge-info',
          },
        ],
      }
    },
    created() {
      this.id = this.$router.currentRoute.params.id
    },
    async mounted() {
      if (this.dataPermission?.includes('CNPS_DFS_TOP_COMMISSION_POLICY_VIEW')) {
        await this.loadData()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),

      // lấy type trạng thái
      getStatusType() {
        const statusMap = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr
          return acc
        }, {})
        return type => {
          return statusMap[type]?.type || type
        }
      },

      // lấy label trạng thái
      getStatusLabel() {
        const statusMap = this.optionStatus.reduce((acc, curr) => {
          acc[curr.id] = curr
          return acc
        }, {})
        return type => {
          return statusMap[type]?.text || type
        }
      },
    },

    methods: {
      openModalDetail(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/sales-manager/detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/contract-detail-ecommerce/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        }
      },
      // back list
      ReturnToList() {
        this.$router.push({ path: '/list-tingbox-ctv' })
      },
      // Update handleOpenModal method
      handleOpenModal(data, type) {
        this.$refs.modalComfirm.handleOpen(data, type)
      },
      // load data
      async loadData() {
        this.isLoading = true
        try {
          const res = await Detail({ id: this.id })
          if (res.code === 1000) {
            this.txPayment = res.data.txPayment
            this.txRecoupment = res.data.txRecoupment
          }
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      formatCurrency(value) {
        return (
          new Intl.NumberFormat('vi-VN', {
            style: 'decimal',
            minimumFractionDigits: 0,
          }).format(value) + 'đ'
        )
      },
      formatDate(timestamp) {
        if (!timestamp) return ''
        const date = new Date(timestamp)
        return new Intl.DateTimeFormat('vi-VN', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).format(date)
      },

      getStatusClass(status) {
        const classMap = {
          PENDING_PAYMENT: 'badge bg-warning text-dark',
          PAID: 'badge bg-success',
          CANCELLED: 'badge bg-danger',
          PENDING_RECOUPMENT: 'badge bg-warning text-dark',
          RECOUPED: 'badge bg-success',
        }
        return classMap[status] || 'badge bg-secondary'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .card {
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }

  .card-header {
    background-color: rgba(0, 0, 0, 0.03);
    padding: 0.75rem 1.25rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  }

  .info-row {
    display: flex;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    border-bottom: 1px solid #eee;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-row label {
    width: 150px;
    color: #666;
    margin-bottom: 0;
  }

  .info-content {
    flex: 1;
  }

  .text-muted {
    color: #6c757d;
    font-size: 0.875rem;
  }

  .badge {
    padding: 0.35em 0.65em;
    border-radius: 0.25rem;
  }

  .bg-success {
    background-color: #28a745;
    color: white;
  }

  .bg-warning {
    background-color: #ffc107;
  }

  .bg-danger {
    background-color: #dc3545;
    color: white;
  }

  .btn {
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    border-radius: 0.2rem;
  }

  .btn-primary {
    background-color: #007bff;
    border-color: #007bff;
    color: white;
  }

  .btn-secondary {
    background-color: #6c757d;
    border-color: #6c757d;
    color: white;
  }

  .text-primary {
    color: #007bff;
  }
  .card-section {
    width: 100%;
    -webkit-box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    // box-shadow: 1px 2px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 4px 16px 0px #0000001f !important;
    padding: 16px;
    border-radius: 10px;

    .cursor-pointer {
      cursor: pointer;
    }

    .header-section {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      position: relative;
      margin-left: 10px;

      &::before {
        content: ' ';
        position: absolute;
        width: 4px;
        height: 24px;
        background: #13569f;
        left: -10px;
      }
    }

    .form-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      // margin-top: 12px;
      margin-top: 6px;
      padding-top: 6px;

      &:first-child {
        margin-top: 0;
      }

      .statusString- {
        width: Hug (61px) px;
        height: Hug (19px) px;
        padding: 2px 8px 2px 8px;
        gap: 8px;
        border-radius: 4px 0px 0px 0px;
        opacity: 0px;
        background: #0056f6;
      }

      & + .form-item {
        // border-top: 1px dotted #ddd;
        border-top: 1px dotted #edf1fa;
      }

      .form-label {
        font-weight: 400;
        font-size: 14px;
        color: #76809b;

        &::after {
          content: ':';
        }

        .icon-arrow {
          width: 30px;
          font-size: 18px !important;
          font-weight: 700;

          svg {
            font-size: 20px !important;
            color: '#2A2A2A';
            font-weight: 700;
          }
        }

        .un-after {
          &::before {
            content: '';
          }
        }
      }

      .form-input {
        width: 68%;
        min-width: 68%;
        // font-weight: 600;
        font-weight: 400;
        margin-left: 10px;
        color: #212633;
        font-size: 14px;

        .image-item {
          width: 100px;
          overflow: hidden;
          overflow-y: hidden;
          border-radius: 5px;
          padding: 2px;
          display: inline-block;

          & + .image-item {
            margin-left: 4px;
          }

          .image {
            border: 1px solid #ddd;
            cursor: pointer;
            height: 80px;
            overflow: hidden;
          }

          .file-name {
            margin-top: 2px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }

        .no-image {
          color: #aaa;
        }

        .location-item {
          margin-top: 2px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }

      .list-task {
        list-style: disc;
        padding-left: 15px;

        li {
          list-style: disc !important;
          padding: 6px 0 !important;
          font-weight: 400;
          font-size: 14px;

          .list-task-image {
            gap: 20px;

            p {
              font-weight: 400;
              font-size: 12px;
              color: gray;
            }

            img {
              border-radius: 5px;
              width: 60px;
              height: 55px;
              border: 1px 0px 0px 0px;
            }

            .no-data {
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>
